var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"exact":""},on:{"click":function($event){$event.stopPropagation();return _vm.disconnect.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$t('sidebar-component-logout-title'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }